import { render, staticRenderFns } from "./crudLostMotive.vue?vue&type=template&id=49b34e99&"
import script from "./crudLostMotive.vue?vue&type=script&lang=js&"
export * from "./crudLostMotive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports